import React from 'react';
import { Row } from 'antd';
import { useTranslation } from 'react-i18next';

import Dropdown from '../../../../common/Dropdown';
import FIELD_TYPES from '../../../../../configs/fieldTypes';
import { getFieldsByType } from '../../../helpers';
import viewSettingsActions from '../../../../../actions/viewSettingsActions';
import { VIEW_MODES, SETTINGS_KEYS } from '../../../../../configs/viewSettings';

import styles from '../config.less';

const Color = (props) => {
  const { t } = useTranslation();

  if (!props.settings) {
    return null;
  }

  const value = props.settings.getIn([SETTINGS_KEYS.COLOR, SETTINGS_KEYS.FIELD_ID]) || null;
  const items = getFieldsByType(props.fields, FIELD_TYPES.DROPDOWN);

  const handleChange = (selectedItem) => {
    const fieldId = selectedItem ? selectedItem.key : null;
    const option = fieldId ? { type: 'field', fieldId } : null;
    viewSettingsActions.setOption({
      catalogId: props.catalogId,
      viewId: props.viewId,
      viewMode: VIEW_MODES.CALENDAR,
      option: SETTINGS_KEYS.COLOR,
      value: option,
    });
  };

  return items ? (
    <Row className={styles.controlRow}>
      <label className={styles.controlLabel}>{t('calendar.config.color')}</label>
      <Dropdown
        disabled={!items.length}
        items={[{ key: null, text: '', sort: -1 }, ...items]}
        value={value}
        autocomplete
        withButton
        multiselect={false}
        onSelectItems={([item]) => handleChange(item)}
      />
    </Row>
  ) : null;
};

export default Color;
